import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from '@resiliatech/birdsong'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1201;
  background: rgba(0, 0, 0, 0.6);
`

export const IconButton = styled.button`
  z-index: 1202;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;

  svg {
    width: 24px;
    height: 24px;
    color: ${colors.interactive.primaryEnabled};
  }
`

export const ModalContainer = styled.div<{
  width?: string
  height?: string
}>`
  display: flex;
  flex-direction: column;
  background: white;
  width: ${({ width }) => width || '50%'};
  height: ${({ height }) => height || 'auto'};
  max-width: 100%;
  max-height: 100%;
  position: fixed;
  z-index: 1202;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 50px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
`

export const ModalBody = styled.div`
  flex: 1;
  width: 100%;
  padding: 40px;
`

export const StepHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 120px 20px 120px;
  color: ${colors.copy.paragraphDark};
`

export const ItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  &:not(:last-child)::after {
    position: absolute;
    content: '';
    top: 20px;
    right: 0;
    height: 1px;
    width: 60%;
    transform: translate(50%, -50%);
    background-color: ${colors.interactive.borderEnabledHoverGray};
  }
`

export const Index = styled.div<{ active: boolean }>`
  position: relative;
  z-index: 1202;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  padding: 8px;
  border-radius: 50%;
  background: ${colors.interactive.secondaryEnabled};
  color: ${colors.copy.paragraphDark};
  margin-bottom: 6px;

  ${({ active }) =>
    active &&
    css`
      background: ${colors.interactive.primaryEnabled};
      color: ${colors.copy.paragraphLight};
    `}
`

export const StepActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 20px;
`

// TODO: Remove PrimaryButton below when Birdsong primary variant receives form prop
// correct implementation should use:
// <Button
//   variant='primary'
//   form={formId}
//   label={actionName}
//   isDisabled={isDisabled}
//   onClick={onNext}
// />

const transformEaseIn = css`
  transition: transform 100ms ease-in;
`
const popOutAnimation = css`
  transform: translate(3px, -3px);
`
export const PrimaryButton = styled.button`
  cursor: pointer;
  display: flex;
  position: relative;
  border-radius: 4px;
  font-weight: 600;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;

  align-items: center;
  background: ${colors.interactive.primaryEnabled};
  border: none;
  color: ${colors.copy.paragraphLight};
  display: flex;
  justify-content: space-between;
  min-height: 40px;
  padding: 8px 17.5px;

  ${transformEaseIn}
  svg {
    color: ${colors.copy.paragraphLight};
    height: 24px;
    width: 24px;
  }

  &:hover {
    background: ${colors.interactive.primaryHoverFocus};
    box-shadow: -3px 3px 0 0 ${colors.interactive.shadowHoverLightBlue},
      0 0 0 1px ${colors.interactive.borderHoverLightBlue} inset;
    color: ${colors.copy.headerLight};

    ${popOutAnimation}
  }

  &:focus {
    background: ${colors.interactive.primaryHoverFocus};
    box-shadow: 0 0 0 3px ${colors.interactive.shadowFocusOrange},
      0 0 0 1px ${colors.interactive.borderFocusOrange} inset;
    color: ${colors.copy.headerLight};
  }

  &:active {
    background: ${colors.interactive.primaryHoverFocus};
    box-shadow: -2px 2px 0 0 ${colors.interactive.shadowHoverLightBlue},
      0 0 0 1px ${colors.interactive.borderActiveLightBlue} inset;
    color: ${colors.copy.headerLight};
  }

  &:disabled {
    background: ${colors.interactive.disabledDark};
    border: 1px solid ${colors.background.primaryBackground};
    color: ${colors.interactive.disabledLight};
    pointer-events: none;

    svg {
      color: ${colors.interactive.disabledLight};
    }
  }
`
